var React = require('react');

function TwoRightRectangles (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M37 28L4 9L4 47L37 28ZM33.3333 28L5.83333 12.1667L5.83333 43.8333L33.3333 28Z","fill":"#404040","key":0}),React.createElement("path",{"d":"M20 10.6795L50 28L20 45.3205L20 10.6795Z","stroke":"#FFCB08","strokeWidth":"2","key":1})]);
}

TwoRightRectangles.defaultProps = {"width":"56","height":"56","viewBox":"0 0 56 56","fill":"none"};

module.exports = TwoRightRectangles;

TwoRightRectangles.default = TwoRightRectangles;
